import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


import { AppComponent } from './app.component';
import { ContentfulService } from './contentful.service';
import { CourseListComponent } from './course-list/course-list.component';
import { CourseDetailsComponent } from './course-details/course-details.component';
import { MdToHtmlPipe } from './md-to-html.pipe';
import { FaqsComponent } from './faqs/faqs.component';
import { IndividualFaqComponent } from './individual-faq/individual-faq.component';
import { PartnersComponent } from './partners/partners.component';

const routes: Routes = [
  /*{ path: '', redirectTo: '/news', pathMatch: 'full'},*/
  { path: 'news', component: CourseListComponent },
  { path: 'news/:id', component: CourseDetailsComponent },
  { path: 'faqs', component: FaqsComponent },
  { path: 'faqs/:id', component: IndividualFaqComponent },
  { path: 'partners', component: PartnersComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    CourseListComponent,
    CourseDetailsComponent,
    MdToHtmlPipe,
    FaqsComponent,
    IndividualFaqComponent,
    PartnersComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes, {useHash: true})
  ],
  providers: [ContentfulService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/app/app.module.ts